<script>
	import API from '../../States/API';
	import Config from '../../Models/Config';
	import Helper from '../../Models/Helper';
	import Session from '../../States/Session';
	import Slider from '../../States/Slider';

	export let index = 0;

	let slide = {};
	let active = false;
	let requested = false;
	let success = false;

	function updateSlider(slides) {
		slide = slides[`slide_${index}`].properties;
		active = slide.active;
		verify();
	}

	async function verify() {
		if (!requested) try {
			requested = true;
			const data = {verification: slide.code};
			const response = await API.verify(data);
			success = !!response.success;
		}
		catch (error) {
			success = false;
			console.error(error);
		}
	}

	Slider.subscribe(updateSlider);
</script>

<style>
	.button.proceed {
		text-align: left;
	}
</style>

<div class="box feature" class:active>
	<div class="menu">
		<div class="begin">
			<div class="title">Registreren</div>
		</div>
		<div class="end">
			<div class="item" on:click="{event => Slider.close()}">
				<i class="fas fa-times"></i>
			</div>
		</div>
	</div>
	<div class="content">
		{#if $API.busy}
			<h1>Registratie Bevestigen</h1>
			<p>Een moment geduld. Jouw registratie wordt bevestigd...</p>
		{:else if !$API.busy && success}
			<h1>Registratie gelukt!</h1>
			<p>Je kunt nu inloggen via de onderstaande knop.</p>
			<div class="button primary solid proceed" on:click="{event => Slider.route('signIn')}">
				<i class="fad fa-chevron-right"></i> Inloggen
			</div>
		{:else if !$API.busy && !success}
			<h1>Er is een fout opgetreden.</h1>
			<p>Jouw registratie kan helaas niet bevestigd worden.</p>
			<a class="button primary solid proceed" href="/start">
				<i class="fad fa-chevron-right"></i> Verder
			</a>
		{/if}
	</div>
</div>